import { useEffect } from "react";

export function setGoogleTranslateCookie(lang,shouldLoad) {
  try {
    // const language = lang === "" ? "en-gb" : lang === 'en-gb' ? 'en' : lang === 'en-us' ? 'en' : lang;
    const language = lang === "" ? "en-gb" : lang 

    // Detect if localhost or real domain
    const hostname = window.location.hostname;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";

    let domain = "";
    if (!isLocalhost) {
      const parts = hostname.split(".");
      domain = parts.length > 2 ? "." + parts.slice(1).join(".") : hostname;
    }

    ["", hostname, domain].forEach(d => {
      if (d) {
        document.cookie = `googtrans=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${d}`;
      } else {
        document.cookie = `googtrans=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
      }
    });

     if (language !== "en-gb") {
    if (isLocalhost) {
      document.cookie = `googtrans=/en/${language};path=/;`;
    } else {
      document.cookie = `googtrans=/en/${language};path=/;domain=${domain}`;
    }
  }
    if (shouldLoad) {
       setTimeout(() => {
      window.location.reload();
    }, 100);
    }
   
  } catch (error) {
    console.log("translate cookie error:", error);
  }
}

function GoogleTranslateElement() {
  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(addScript);

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "", autoDisplay: false },
        "google_translate_element"
      );
    };
  }, []);

  return <div id="google_translate_element" style={{ display: "none" }}></div>;
}

export default GoogleTranslateElement;
